import React, { useEffect, useRef, useState, useContext } from "react";
import "./Sidebar.scss";
import "./SidebarMenu.scss";
import "./BuilderSidebar.scss";
import { Link, useLocation, useHistory } from "react-router-dom";
import { ICONS } from "./BuilderSidebar";
import { __ } from "services/Translator";
import { categoryByRoute, leftVisible, buildSidebarTree } from "services/categories";
import { MENU_ICONS, badgePill, resolveAccent } from "services/menuAppearance";
import auth from "services/auth";
import AppContext from "contexts/AppContext";
import Logo from "elements/Logo";

import SearchBox from "elements/SearchBox";
import LanguageSwitcherAccordion from "components/LanguageSwitcherAccordion";

// Built-in inline section icons (they recolor with the theme, unlike an uploaded
// <img>). Keyed by the group's api_slug so a dynamic section header shows the
// familiar umbrella icon instead of a neutral dot. An admin-uploaded icon_left
// still wins; child items stay on the dot as before.
// MENU_ICONS / badge / accent primitives moved to services/menuAppearance so
// the horizontal strip and category page heading render the same set.

const SECTION_ICONS = {
  casino_section: (
    <svg fill="#F9D722" height="26px" width="26px" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 420.751 420.751">
      <g><g><g><path d="M374.431,130.094c5.233,0,9.969-2.12,13.399-5.55c3.43-3.43,5.55-8.166,5.55-13.399c0-10.465-8.484-18.944-18.949-18.944 s-18.949,8.484-18.949,18.944C355.482,121.61,363.965,130.094,374.431,130.094z"/><path d="M99.092,328.642c-9.8,0-17.741,7.946-17.741,17.741c0,9.795,7.946,17.741,17.741,17.741s17.741-7.941,17.741-17.741 C116.833,336.584,108.892,328.642,99.092,328.642z"/><path d="M365.962,140.385v152.873h16.937V140.385c-2.56,1.29-5.407,2.084-8.468,2.084 C371.369,142.469,368.522,141.67,365.962,140.385z"/><path d="M245.74,328.642c-9.8,0-17.741,7.946-17.741,17.741c0,9.795,7.941,17.741,17.741,17.741s17.741-7.941,17.741-17.741 C263.48,336.584,255.539,328.642,245.74,328.642z"/><path d="M332.037,11.658H9.907C4.434,11.658,0,16.092,0,21.565v387.528h341.949V21.565 C341.944,16.092,337.51,11.658,332.037,11.658z M231.511,35.82c8.238,0,14.915,6.676,14.915,14.915s-6.677,14.915-14.915,14.915 c-8.238,0-14.915-6.676-14.915-14.915C216.597,42.496,223.273,35.82,231.511,35.82z M172.416,24.064 c14.725,0,26.665,11.94,26.665,26.665c0,14.725-11.94,26.665-26.665,26.665c-14.725,0-26.665-11.94-26.665-26.665 C145.751,36.004,157.691,24.064,172.416,24.064z M113.321,35.82c8.238,0,14.915,6.676,14.915,14.915s-6.677,14.915-14.915,14.915 c-8.238,0-14.915-6.676-14.915-14.915C98.412,42.496,105.088,35.82,113.321,35.82z M99.092,374.41 c-15.478,0-28.022-12.544-28.022-28.022s12.549-28.022,28.022-28.022c15.478,0,28.022,12.549,28.022,28.022 C127.114,361.861,114.57,374.41,99.092,374.41z M172.416,374.41c-15.478,0-28.022-12.544-28.022-28.022 s12.544-28.022,28.022-28.022c15.478,0,28.022,12.549,28.022,28.022C200.438,361.861,187.894,374.41,172.416,374.41z M245.74,374.41c-15.478,0-28.022-12.544-28.022-28.022s12.544-28.022,28.022-28.022c15.478,0,28.022,12.549,28.022,28.022 C273.761,361.861,261.217,374.41,245.74,374.41z M320.323,280.407H24.509V90.987h295.813V280.407z"/><path d="M172.416,328.642c-9.8,0-17.741,7.946-17.741,17.741c0,9.795,7.946,17.741,17.741,17.741 c9.8,0,17.741-7.941,17.741-17.741C190.157,336.584,182.216,328.642,172.416,328.642z"/><path d="M113.326,108.006h-0.005H36.618v155.121h76.708V108.006z"/><path d="M381.348,303.278h-28.437v78.812h28.437c21.765,0,39.404-17.643,39.404-39.404 C420.756,320.922,403.113,303.278,381.348,303.278z"/><path d="M303.324,108.006h-0.005h-76.703v155.121h76.708V108.006z"/><path d="M208.323,108.006h-76.708v155.121h76.708V108.006z"/></g></g></g>
    </svg>
  ),
  live_casino_section: (
    <svg fill="#F9D722" width="34px" height="34px" viewBox="0 0 512 512" id="Croupier" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g><g><path d="M408.709,372.949c-1.652-16.627-11.465-31.202-26.248-38.988l-68.949-36.313l-16.546-18.374v-13.351 c10.308-6.362,18.824-14.938,25.087-24.905c17.756,50.995,67.18,43.242,54.729,37.582c-13.2-6-10.801-21.6-3.601-50.399 c7.2-28.8,4.8-42-10.8-57.6c-3.447-3.448-7.128-5.364-10.771-6.265c-0.564-2.503-1.517-4.856-2.797-6.999 c5.604-12.011,9.638-31.11,2.938-46.341C351.11,70.711,307.908,38.2,254.681,38.2c-53.626,0-97.1,32.997-97.1,73.7h0.077 c-6.302,15.439-1.965,34.563,3.732,46.281c-1.85,3.403-2.908,7.296-2.908,11.434v8.355c0,11.249,7.77,20.716,18.225,23.317 c0.586,27.041,15.057,51.677,38.289,65.401v12.586l-16.581,18.412l-68.875,36.275c-14.784,7.786-24.597,22.361-26.249,38.988 L93.268,473.8h325.464L408.709,372.949z M106.52,461.8l8.712-87.664c1.252-12.604,8.691-23.655,19.899-29.558l62.061-32.686 l0.12,1.047l-25.918,55.824c-1.665,3.587-0.53,7.852,2.698,10.135l81.89,57.953l81.891-57.953 c3.228-2.283,4.362-6.548,2.697-10.135l-25.918-55.824l0.121-1.066l62.098,32.705c11.207,5.902,18.646,16.953,19.898,29.558 l8.713,87.664H106.52z"/></g></g>
    </svg>
  ),
};

// Custom hook to detect if screen is mobile
function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);
  return isMobile;
}

const Sidebar = ({ isCollapsed, toggleSidebar, ...props }) => {
  const sidebarHeaderTitleRef = useRef(null);
  const navItemRefs = useRef([]);
  const isMobile = useIsMobile();
  const location = useLocation();
  const history = useHistory();
  const { updateUserAuthStatus } = useContext(AppContext);
  const [hoveredItem, setHoveredItem] = useState(null);

  // Helper function to check if link is active
  const isActiveLink = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  // Logged-out users: open the sign-up modal from the sidebar. The pulse back to
  // false lets the same CTA re-open the modal after it's dismissed.
  const openSignupModal = (ev) => {
    ev.preventDefault();
    closeSidebarOnMobile();
    props.setModalSignUpPropsData(true);
    setTimeout(() => props.setModalSignUpPropsData(false), 500);
  };

  const openLoginModal = (ev) => {
    ev.preventDefault();
    closeSidebarOnMobile();
    props.setModalLoginPropsData(true);
    setTimeout(() => props.setModalLoginPropsData(false), 500);
  };

  // Log out and return to the root (which shows the onboarding for PWA guests).
  const handleLogout = async (ev) => {
    ev.preventDefault();
    closeSidebarOnMobile();
    await auth.logout();
    updateUserAuthStatus();
    history.push("/");
  };

  // Account sub-menu items (logged-in users) — all handled by UserDashboard.
  const accountSubItems = [
    { label: __("Account Details"), url: "/dashboard/account-details" },
    { label: __("Messages"), url: "/messages", badge: props.notificationCount },
    { label: __("Free Spins"), url: "/dashboard/free-spins" },
    { label: __("Favorite Games"), url: "/dashboard/my-games" },
    { label: __("Preferences"), url: "/dashboard/preferences" },
  ];
  const ICONS = {
    Activities: (
      <img
        src="https://cdn.ninestatic.com/front/components/sidebar/png/missions.png"
        alt="Activities"
        width={40}
        height={40}
      />
    ),
    Casino: (
      <svg viewBox="0 0 24 24" width="24" height="24" fill="none">
        <path
          d="M6.5 22c2.485 0 4.5-2.04 4.5-4.557a4.57 4.57 0 0 0-1.035-2.907c.848-.885 1.774-2.32 2.496-3.976.729-1.673 1.285-3.656 1.326-5.659q.267.189.531.468c.468.496.886 1.167 1.243 1.921.602 1.273.98 2.683 1.13 3.644C14.592 11.32 13 13.181 13 15.418c0 2.517 2.015 4.557 4.5 4.557s4.5-2.04 4.5-4.557c0-2.274-1.645-4.16-3.795-4.502-.151-1.128-.586-2.79-1.291-4.282-.398-.84-.898-1.664-1.51-2.314-.18-.19-.374-.37-.58-.531l.913-.309a.76.76 0 0 0 .475-.96.75.75 0 0 0-.949-.48l-4.5 1.518a.76.76 0 0 0-.474.96.75.75 0 0 0 .948.481l1.052-.355c.005 1.815-.495 3.684-1.2 5.303-.71 1.627-1.585 2.912-2.262 3.595a4.44 4.44 0 0 0-2.327-.656c-2.485 0-4.5 2.04-4.5 4.557S4.015 22 6.5 22"
          fill="currentColor"
        ></path>
      </svg>
    ),
    Live: (
      <svg viewBox="0 0 24 24" width="24" height="24" fill="none">
        <path
          d="M6.343 4.938a1 1 0 0 1 0 1.415 8.003 8.003 0 0 0 0 11.317 1 1 0 1 1-1.415 1.414c-3.906-3.906-3.906-10.24 0-14.146a1 1 0 0 1 1.415 0m12.731 0c3.906 3.907 3.906 10.24 0 14.146a1 1 0 0 1-1.414-1.414 8.003 8.003 0 0 0 0-11.317 1 1 0 0 1 1.414-1.415M9.31 7.812a1 1 0 0 1 0 1.414 3.92 3.92 0 0 0 0 5.544 1 1 0 1 1-1.414 1.414 5.92 5.92 0 0 1 0-8.372 1 1 0 0 1 1.414 0m6.959 0a5.92 5.92 0 0 1 0 8.372 1 1 0 0 1-1.415-1.414 3.92 3.92 0 0 0 0-5.544 1 1 0 0 1 1.415-1.414m-4.187 2.77a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
          fill="currentColor"
        ></path>
      </svg>
    ),
    Support: (
      <svg viewBox="0 0 24 24" width="24" height="24" fill="none">
        <path
          d="M12 3C6.477 3 2 7.477 2 13v3a3 3 0 0 0 3 3h1a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H5v-1c0-4.418 3.582-8 8-8s8 3.582 8 8v1h-1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1a3 3 0 0 0 3-3v-3c0-5.523-4.477-10-10-10z"
          stroke="#09e41f"
          strokeWidth="2"
          fill="none"
        />
        <rect x="4" y="15" width="3" height="4" rx="1" fill="#161d37" stroke="#09e41f" strokeWidth="2" />
        <rect x="17" y="15" width="3" height="4" rx="1" fill="#161d37" stroke="#09e41f" strokeWidth="2" />
      </svg>
    ),
  };
  useEffect(() => {
    // Handle staggered transition for text on collapse/expand
    const sidebarHeaderTitle = sidebarHeaderTitleRef.current;
    const navItems = navItemRefs.current;
    // alert(isCollapsed);
    if (isCollapsed) {
      if (sidebarHeaderTitle) sidebarHeaderTitle.style.transitionDelay = "0s";
      navItems.forEach((item) => {
        if (item) item.style.transitionDelay = "0s";
      });
    } else {
      if (sidebarHeaderTitle) sidebarHeaderTitle.style.transitionDelay = "0.1s";
      navItems.forEach((item, index) => {
        if (item) item.style.transitionDelay = `${0.05 * index + 0.1}s`;
      });
    }
  }, [isCollapsed]);
  const handleSupportSidebarToggle = (event) => {
    event?.preventDefault();
    if (typeof props.setSupportSidebarOpen === "function") {
      props.setSupportSidebarOpen(!props.supportSidebarOpen);
    } else if (process.env.NODE_ENV !== "production") {
      console.warn("[Sidebar] setSupportSidebarOpen handler missing");
    }
    if (typeof props.setShowRightSidebar === "function") {
      props.setShowRightSidebar(false);
    }
  };
  const [hovered, setHovered] = useState(null);
  const [open, setOpen] = useState(null);
  // Account accordion uses its own state so it is never collapsed by the
  // game-category accordions (which share the single `open` state).
  const [accountOpen, setAccountOpen] = useState(false);
  const [submenuHover, setSubmenuHover] = useState(null);

  // The section grouping is editorial (the API has no notion of it), so
  // the curated structure and ORDER stay; per item the API drives the
  // label (verbatim, already per-scope translated) and the show_in_left
  // visibility. No API data = today's hardcoded items, unchanged.
  const categoryChildren = (children) => {
    return children
      .map((child) => {
        var routeSlug = child.url.replace("/games/", "");
        var category = categoryByRoute(props.categories, routeSlug);
        if (!category) {
          return child;
        }
        return {
          ...child,
          label: child.keepLabel ? child.label : category.label,
          apiSlug: category.api_slug,
        };
      })
      .filter((child) => !child.apiSlug || leftVisible(props.categories, child.apiSlug));
  };

  // Fully dynamic left menu built from the API tree (parent_id + is_group via
  // array adjacency). Sections come from top-level rows: a group renders as a
  // header with its children, a plain category as a link, a category that also
  // has children as an accordion reachable through a leading self-link. Icons
  // render in the fixed slot left of the label; a missing icon gets a neutral
  // dot. When the API is unavailable buildSidebarTree returns null and the menu
  // falls back to the hardcoded accordion below, byte-identical to today.
  // Icon precedence: an uploaded icon_left wins, then an emoji, then a built-in
  // icon_key, then a legacy per-section umbrella (apiSlug), then the neutral dot.
  const menuIcon = (item) => {
    const it = item || {};
    if (it.iconLeft) {
      return (
        <img
          src={it.iconLeft}
          alt=""
          width="20"
          height="20"
          style={{ width: "20px", height: "20px", objectFit: "contain" }}
        />
      );
    }
    if (it.iconEmoji) {
      return (
        <span style={{ fontSize: "17px", lineHeight: 1, display: "inline-flex", width: "20px", justifyContent: "center" }}>
          {it.iconEmoji}
        </span>
      );
    }
    const inline =
      (it.iconKey && MENU_ICONS[it.iconKey]) ||
      (it.apiSlug && SECTION_ICONS[it.apiSlug]);
    if (inline) {
      return inline;
    }
    return (
      <svg viewBox="0 0 24 24" fill="none" width="16" height="16" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="3" fill={resolveAccent(it.accent) || "#A2A5AF"} />
      </svg>
    );
  };

  // Accent: an inset left bar in the accent colour; featured: a faint tinted
  // background (accent colour, or gold when only featured). No layout shift.
  const rowStyle = (it) => {
    const s = {};
    if (it.accentHex) {
      s.boxShadow = "inset 3px 0 0 " + it.accentHex;
    }
    if (it.isFeatured) {
      s.background = (it.accentHex || "#eab308") + "1f";
    }
    return s;
  };
  // apiSlug is always present; it backstops a (malformed) row with no route_slug
  // so a menu link can never become "/games/null".
  const mapLeaf = (leaf) => ({
    label: leaf.label,
    badge: leaf.badge || null,
    accentHex: resolveAccent(leaf.accent),
    isFeatured: !!leaf.isFeatured,
    url: leaf.menuType === "link" && leaf.linkUrl ? leaf.linkUrl : "/games/" + (leaf.routeSlug || leaf.apiSlug),
    icon: menuIcon(leaf),
  });

  const dynamicAccordion = (() => {
    const tree = buildSidebarTree(props.categories);
    if (!tree) {
      return null;
    }
    return tree.map((section) => {
      const icon = menuIcon(section);
      const accentHex = resolveAccent(section.accent);
      const isFeatured = !!section.isFeatured;
      if (section.isGroup) {
        return { key: section.apiSlug, label: section.label, badge: section.badge || null, accentHex, isFeatured, icon, children: section.children.map(mapLeaf) };
      }
      if (section.children.length) {
        return {
          key: section.apiSlug,
          label: section.label,
          badge: section.badge || null,
          accentHex,
          isFeatured,
          icon,
          // The accordion header already shows the section badge; the leading
          // self-link would repeat the same pill right under it.
          children: [{ ...mapLeaf(section), badge: null }, ...section.children.map(mapLeaf)],
        };
      }
      const url = section.menuType === "link" && section.linkUrl ? section.linkUrl : "/games/" + (section.routeSlug || section.apiSlug);
      return { key: section.apiSlug, label: section.label, badge: section.badge || null, accentHex, isFeatured, url, icon };
    });
  })();

  const fallbackAccordion = [
    {
      key: "casino",
      icon: (
        // <Lottie
        //   className="lottie-container"
        //   style={{ width: "40px", height: "40px", marginRight: "10px" }}
        //   animationData={casinoIcon}
        //   loop={hoveredItem === "casino"}
        //   autoplay={hoveredItem === "casino"}
        // />
        <svg fill="#F9D722" height="26px" width="26px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 420.751 420.751" >

          <g id="SVGRepo_bgCarrier" strokeWidth="0" />

          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />

          <g id="SVGRepo_iconCarrier"> <g> <g> <path d="M374.431,130.094c5.233,0,9.969-2.12,13.399-5.55c3.43-3.43,5.55-8.166,5.55-13.399c0-10.465-8.484-18.944-18.949-18.944 s-18.949,8.484-18.949,18.944C355.482,121.61,363.965,130.094,374.431,130.094z" /> <path d="M99.092,328.642c-9.8,0-17.741,7.946-17.741,17.741c0,9.795,7.946,17.741,17.741,17.741s17.741-7.941,17.741-17.741 C116.833,336.584,108.892,328.642,99.092,328.642z" /> <path d="M365.962,140.385v152.873h16.937V140.385c-2.56,1.29-5.407,2.084-8.468,2.084 C371.369,142.469,368.522,141.67,365.962,140.385z" /> <path d="M245.74,328.642c-9.8,0-17.741,7.946-17.741,17.741c0,9.795,7.941,17.741,17.741,17.741s17.741-7.941,17.741-17.741 C263.48,336.584,255.539,328.642,245.74,328.642z" /> <path d="M332.037,11.658H9.907C4.434,11.658,0,16.092,0,21.565v387.528h341.949V21.565 C341.944,16.092,337.51,11.658,332.037,11.658z M231.511,35.82c8.238,0,14.915,6.676,14.915,14.915s-6.677,14.915-14.915,14.915 c-8.238,0-14.915-6.676-14.915-14.915C216.597,42.496,223.273,35.82,231.511,35.82z M172.416,24.064 c14.725,0,26.665,11.94,26.665,26.665c0,14.725-11.94,26.665-26.665,26.665c-14.725,0-26.665-11.94-26.665-26.665 C145.751,36.004,157.691,24.064,172.416,24.064z M113.321,35.82c8.238,0,14.915,6.676,14.915,14.915s-6.677,14.915-14.915,14.915 c-8.238,0-14.915-6.676-14.915-14.915C98.412,42.496,105.088,35.82,113.321,35.82z M99.092,374.41 c-15.478,0-28.022-12.544-28.022-28.022s12.549-28.022,28.022-28.022c15.478,0,28.022,12.549,28.022,28.022 C127.114,361.861,114.57,374.41,99.092,374.41z M172.416,374.41c-15.478,0-28.022-12.544-28.022-28.022 s12.544-28.022,28.022-28.022c15.478,0,28.022,12.549,28.022,28.022C200.438,361.861,187.894,374.41,172.416,374.41z M245.74,374.41c-15.478,0-28.022-12.544-28.022-28.022s12.544-28.022,28.022-28.022c15.478,0,28.022,12.549,28.022,28.022 C273.761,361.861,261.217,374.41,245.74,374.41z M320.323,280.407H24.509V90.987h295.813V280.407z" /> <path d="M172.416,328.642c-9.8,0-17.741,7.946-17.741,17.741c0,9.795,7.946,17.741,17.741,17.741 c9.8,0,17.741-7.941,17.741-17.741C190.157,336.584,182.216,328.642,172.416,328.642z" /> <path d="M113.326,108.006h-0.005H36.618v155.121h76.708V108.006z M103.434,172.104c-0.01,0-0.015,0-0.02,0 c0,0.107,0.02,0.195,0.02,0.302c0,18.186-27.192,24.827-16.246,50.714H57.718c-3.722-23.219,28.667-35.164,30.853-47.8 c-3.195,1.244-6.359,2.381-11.069,2.381c-9.651,0-10.593-4.721-23.634-5.478v9.175h-7.363v-20.7h7.363v0.113 c13.041,0.763,13.983,5.478,23.634,5.478c10.491,0,13.292-5.596,25.933-5.596V172.104z" /> <path d="M381.348,303.278h-28.437v78.812h28.437c21.765,0,39.404-17.643,39.404-39.404 C420.756,320.922,403.113,303.278,381.348,303.278z" /> <path d="M303.324,108.006h-0.005h-76.703v155.121h76.708V108.006z M293.432,172.104c-0.01,0-0.015,0-0.02,0 c0,0.107,0.02,0.195,0.02,0.302c0,18.186-27.192,24.827-16.246,50.714h-29.471c-3.722-23.219,28.667-35.164,30.853-47.8 c-3.195,1.244-6.359,2.381-11.069,2.381c-9.651,0-10.593-4.721-23.634-5.478v9.175h-7.363v-20.7h7.363v0.113 c13.041,0.763,13.988,5.478,23.634,5.478c10.491,0,13.292-5.596,25.933-5.596V172.104z" /> <path d="M208.323,108.006h-76.708v155.121h76.708V108.006z M198.436,172.104c-0.01,0-0.015,0-0.021,0 c0,0.107,0.021,0.195,0.021,0.302c0,18.186-27.192,24.827-16.246,50.714h-29.471c-3.722-23.219,28.667-35.164,30.853-47.8 c-3.195,1.244-6.359,2.381-11.069,2.381c-9.646,0-10.593-4.721-23.634-5.478v9.175h-7.363v-20.7h7.363v0.113 c13.041,0.763,13.988,5.478,23.634,5.478c10.491,0,13.292-5.596,25.933-5.596V172.104z" /> </g> </g> </g>

        </svg>
      ),
      label: __("Casino"),
      children: categoryChildren([
        { label: __("All Games"), url: "/games/all" },
        { label: __("Slots"), url: "/games/slots" },
        { label: __("Bonus Buy"), url: "/games/bonus-buy" },
        { label: __("Megaways"), url: "/games/megaways" },
        { label: __("Crash Games"), url: "/games/crash" },
        { label: __("Drops & Wins"), url: "/games/drops-wins" },
        { label: __("Jackpot Games"), url: "/games/jackpot" },
        { label: __("Video Table Games"), url: "/games/table-games" },
        { label: __("Live Casino"), url: "/games/live-casino" },
        { label: __("New"), url: "/games/new" },
      ]),
    },
    {
      key: "live",
      icon: (
        // <Lottie
        //   className="lottie-container"
        //   style={{ width: "40px", height: "40px", marginRight: "10px" }}
        //   animationData={livecasinoIcon}
        //   loop={hoveredItem === "live"}
        //   autoplay={hoveredItem === "live"}
        // />
        <svg fill="#F9D722" width="34px" height="34px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" id="Croupier" version="1.1" >

          <g id="SVGRepo_bgCarrier" strokeWidth="0" />

          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />

          <g id="SVGRepo_iconCarrier"> <g> <path d="M408.709,372.949c-1.652-16.627-11.465-31.202-26.248-38.988l-68.949-36.313l-16.546-18.374v-13.351 c10.308-6.362,18.824-14.938,25.087-24.905c17.756,50.995,67.18,43.242,54.729,37.582c-13.2-6-10.801-21.6-3.601-50.399 c7.2-28.8,4.8-42-10.8-57.6c-3.447-3.448-7.128-5.364-10.771-6.265c-0.564-2.503-1.517-4.856-2.797-6.999 c5.604-12.011,9.638-31.11,2.938-46.341C351.11,70.711,307.908,38.2,254.681,38.2c-53.626,0-97.1,32.997-97.1,73.7h0.077 c-6.302,15.439-1.965,34.563,3.732,46.281c-1.85,3.403-2.908,7.296-2.908,11.434v8.355c0,11.249,7.77,20.716,18.225,23.317 c0.586,27.041,15.057,51.677,38.289,65.401v12.586l-16.581,18.412l-68.875,36.275c-14.784,7.786-24.597,22.361-26.249,38.988 L93.268,473.8h325.464L408.709,372.949z M246.373,352.08l-5.273,47.627l-13.905-34.71l17.072-19.396L246.373,352.08z M267.722,345.596l17.052,19.387l-13.888,34.664l-5.271-47.566L267.722,345.596z M297.102,360.846l-33.19-37.705l20.498-24.118 l6.892-8.107l12.234,13.587L297.102,360.846z M188.688,199.581v-9.586h-6.182c-6.63,0-12.024-5.394-12.024-12.024v-8.355 c0-0.225,0.021-0.444,0.034-0.666c0.223,0.015,0.443,0.017,0.656,0.033c0.022,0,0.039,0,0.061,0 c5.455,0.243,10.798-3.372,16.942-11.391h0.514v-0.682c4.569-6.102,9.587-14.605,15.425-25.754 c8.096-15.413,20.845-16.07,30.512-13.646c2.836,1.878,4.669,2.959,4.669,2.959l14.175,8.47l11.312-7.389 c7.699-4.067,29.203-12.71,40.898,9.606c13.885,26.511,23.14,38.123,32.718,37.828c0.38,0,0.753,0,1.114-0.05 c0.174-0.021,0.398-0.115,0.652-0.254c0.024,0.311,0.053,0.621,0.053,0.938v8.355c0,6.63-5.395,12.024-12.025,12.024h-6.182v9.586 c0,0.968-0.028,1.931-0.07,2.892c-0.012,0.244-0.024,0.487-0.037,0.73c-0.049,0.873-0.111,1.742-0.193,2.608 c-0.009,0.089-0.014,0.179-0.023,0.268c-0.097,0.979-0.219,1.953-0.359,2.923c-0.023,0.16-0.049,0.318-0.074,0.478 c-0.139,0.912-0.293,1.819-0.471,2.722c-0.012,0.06-0.021,0.121-0.033,0.182c-0.203,1.015-0.428,2.023-0.676,3.024 c-0.005,0.019-0.01,0.037-0.015,0.056c-0.25,1.002-0.522,1.997-0.819,2.984c-0.004,0.014-0.008,0.028-0.012,0.042 c-0.604,2.009-1.303,3.985-2.091,5.921c-5.584,13.707-15.714,25.4-29.085,32.832l-3.085,1.715v20.877L263.63,304.94l-7.649,8.999 l-28.985-34.102v-20.277l-3.19-1.69C202.144,246.392,188.688,224.056,188.688,199.581z M220.661,290.914l27.389,32.225 l-33.189,37.703l-6.435-56.34L220.661,290.914z M106.52,461.8l8.712-87.664c1.252-12.604,8.691-23.655,19.899-29.558l62.061-32.686 l0.12,1.047l-25.918,55.824c-1.665,3.587-0.53,7.852,2.698,10.135l81.89,57.953l81.891-57.953 c3.228-2.283,4.362-6.548,2.697-10.135l-25.918-55.824l0.121-1.066l62.098,32.705c11.207,5.902,18.646,16.953,19.898,29.558 l8.713,87.664H106.52z" /> <path d="M362.645,416.668h-46.113h-3.055c-2.028,0-3.673,1.958-3.673,4.373v15.475c0,2.415,1.645,4.373,3.673,4.373h49.168 c1.775,0,3.256-1.499,3.599-3.492c0.049-0.284,0.075-0.579,0.075-0.881v-2.355v-13.119 C366.318,418.626,364.673,416.668,362.645,416.668z" /> </g> </g>

        </svg>
      ),
      label: __("Live Casino"),
      children: categoryChildren([
        { label: __("All Live Games"), url: "/games/live-casino", keepLabel: true },
        { label: __("Blackjack"), url: "/games/blackjack" },
        { label: __("Roulette"), url: "/games/roulette" },
        { label: __("Baccarat"), url: "/games/baccarat" },
        { label: __("Game Shows"), url: "/games/game-shows" },
      ]),
    },
  ].filter((section) => section.children.length > 0);

  // API tree drives the menu; the hardcoded accordion is the API-down fallback.
  const accordionData = dynamicAccordion || fallbackAccordion;

  const Divider = () => <div className="builder-sidebar-divider my-5" />;

  const ICON_LABELS = [__("Activities"), __("Casino"), __("Live casino"), __("Sports"), __("Esports"), __("Support")];

  const ChevronLeftIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M15 18l-6-6 6-6"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const ChevronRightIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M9 18l6-6-6-6"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const RaceIcon = ({ size = 28 }) => (
    <svg
      className="sidebar-icon"
      fill="#F9D722"
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path d="M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H8v2h8v-2h-3v-6.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-2 2.82V7h2v1z" />
    </svg>
  );

  const ProvidersIcon = ({ size = 28 }) => (
    <svg
      className="sidebar-icon"
      fill="#F9D722"
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path d="M4 4h7v7H4V4zm9 0h7v7h-7V4zM4 13h7v7H4v-7zm9 0h7v7h-7v-7z" />
    </svg>
  );

  const MissionsIcon = ({ size = 28 }) => (
    <svg
      className="sidebar-icon"
      fill="#F9D722"
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path d="M13 2 4 14h6l-1 8 11-14h-6l1-8z" />
    </svg>
  );

  const RewardsIcon = ({ size = 28 }) => (
    <svg
      className="sidebar-icon"
      fill="#F9D722"
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path d="M20 7h-2.18C17.93 5.55 16.29 4 14.25 4c-1.52 0-2.87.78-3.66 1.96L12 7l-1.59-2.04A4.24 4.24 0 0 0 6.75 4C4.71 4 3.07 5.55 2.18 7H2v2h20V7zm0 4H4v9c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-9zM12 11v7H6v-7h6zm8 0v7h-6v-7h6z" />
    </svg>
  );

  const StoreIcon = ({ size = 28 }) => (
    <svg
      className="sidebar-icon"
      fill="#F9D722"
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path d="M7 7V6a5 5 0 0 1 10 0v1h2a1 1 0 0 1 1 1v2H4V8a1 1 0 0 1 1-1h2zm2 0h6V6a3 3 0 0 0-6 0v1zm-4 5h16v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7z" />
    </svg>
  );

  const WheelIcon = ({ size = 28 }) => (
    <svg
      className="sidebar-icon"
      fill="#F9D722"
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 2.2a7.8 7.8 0 1 1 0 15.6 7.8 7.8 0 0 1 0-15.6Zm0 2.8a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm0 1.8a3.2 3.2 0 1 1 0 6.4 3.2 3.2 0 0 1 0-6.4ZM12 4.5V7M12 17v2.5M4.5 12H7M17 12h2.5M6.1 6.1l1.8 1.8M16.1 16.1l1.8 1.8M6.1 17.9l1.8-1.8M16.1 7.9l1.8-1.8" />
    </svg>
  );

  const VipIcon = ({ size = 28 }) => (
    <svg
      className="sidebar-icon"
      fill="#F9D722"
      width={size}
      height={size}
      viewBox="-4 0 32 32"
      aria-hidden="true"
    >
      <path d="M4.219 23.719l-1.656-9.063c0.5-0.094 0.969-0.375 1.344-0.688 1.031 0.938 2.344 1.844 3.594 1.844 1.5 0 2.719-2.313 3.563-4.25 0.281 0.094 0.625 0.188 0.938 0.188s0.656-0.094 0.938-0.188c0.844 1.938 2.063 4.25 3.563 4.25 1.25 0 2.563-0.906 3.594-1.844 0.375 0.313 0.844 0.594 1.344 0.688l-1.656 9.063h-15.563zM3.875 24.5h16.25v1.531h-16.25v-1.531z" />
    </svg>
  );

  const closeSidebarOnMobile = () => {
    if (props.isMobileDevice) {
      props.setIsSidebarCollapsed(!props.isSidebarCollapsed);
    }
  };

  const handleSidebarLinkClick = (fn) => (event) => {
    if (fn) fn(event);
    closeSidebarOnMobile();
  };

  const SidebarNavLink = ({
    to,
    active,
    onClick,
    onMouseEnter,
    onMouseLeave,
    icon,
    label,
    title,
  }) => (
    <Link
      to={to}
      title={title}
      className={`sidebar-btn w-100 d-flex align-items-center mb-2 ${label ? "" : "sidebar-btn-center justify-content-center"} ${active ? "active" : ""}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick ? handleSidebarLinkClick(onClick) : closeSidebarOnMobile}
    >
      <span className="sidebar-btn__icon" aria-hidden="true">
        {icon}
      </span>
      {label ? <span className="fw-bold sidebar-btn__label">{label}</span> : null}
    </Link>
  );

  return (
    <>
    <aside
      id="primary-sidebar"
      className={`sidebar  ${isCollapsed ? "collapsed" : ""} ${props.isMobileDevice ? "mobile" : "desktop"}`}
      aria-label={__("Main sidebar")}
    >
      {/* <Logo /> */}
      <SearchBox {...props} />

      {!props.isSidebarCollapsed && (
        <>
          <div className="sidebar-menu-main slide-up-opacity flex-grow-1 d-flex flex-column">
            {/* Account section — first block in the expanded sidebar (GoldenClover only). */}
            <div className="sidebar-menu-section py-3 px-3">
              <ul className="sidebar-menu-list list-unstyled">
                <li className="sidebar-list-item mb-2">
                  {props.isAuthenticated ? (
                    <>
                      <div
                        className="sidebar-accordion-button"
                        onClick={() => setAccountOpen(!accountOpen)}
                        onMouseEnter={() => setHoveredItem("account")}
                        onMouseLeave={() => setHoveredItem(null)}
                      >
                        <div className="menu-item-area">
                          <div className="menu-icon">
                            <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor" aria-hidden="true">
                              <path d="M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm0 2c-5.33 0-8 2.67-8 5v1h16v-1c0-2.33-2.67-5-8-5z" />
                            </svg>
                          </div>
                          <div className="menu-text">{__("Account")}</div>
                        </div>
                        <div className={`accordion-chevron ${accountOpen ? "open" : "closed"}`}>
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path
                              d="M4.293 8.293a1 1 0 0 1 1.414 0L12 14.586l6.293-6.293a1 1 0 1 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 0-1.414"
                              fill="currentColor"
                            />
                          </svg>
                        </div>
                      </div>
                      {accountOpen && (
                        <ul className="accordion-submenu">
                          {accountSubItems.map((item, idx) => (
                            <li key={idx} className="accordion-submenu-item">
                              <Link
                                className="nav-sidebar-item nav-sidebar-item--nested"
                                to={item.url}
                                onClick={closeSidebarOnMobile}
                              >
                                <div className="nav-sidebar-item__content">
                                  <div className="m-icon-container nav-sidebar-item-icon">
                                    <svg viewBox="0 0 24 24" fill="none" width="16" height="16">
                                      <circle cx="12" cy="12" r="3" fill="#A2A5AF" />
                                    </svg>
                                  </div>
                                  <span className="nav-sidebar-item-text">{item.label}</span>
                                  {item.badge > 0 && (
                                    <span
                                      style={{
                                        marginLeft: "auto",
                                        background: "#dc3545",
                                        color: "#fff",
                                        borderRadius: "10px",
                                        padding: "0 6px",
                                        fontSize: "11px",
                                        fontWeight: 700,
                                        lineHeight: "18px",
                                      }}
                                    >
                                      {item.badge}
                                    </span>
                                  )}
                                </div>
                              </Link>
                            </li>
                          ))}
                          <li className="accordion-submenu-item">
                            <a
                              className="nav-sidebar-item nav-sidebar-item--nested"
                              href="#"
                              onClick={handleLogout}
                            >
                              <div className="nav-sidebar-item__content">
                                <div className="m-icon-container nav-sidebar-item-icon">
                                  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
                                    <path d="M16 17v-3H9v-4h7V7l5 5-5 5zM14 2a2 2 0 0 1 2 2v2h-2V4H5v16h9v-2h2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9z" />
                                  </svg>
                                </div>
                                <span className="nav-sidebar-item-text">{__("Logout")}</span>
                              </div>
                            </a>
                          </li>
                        </ul>
                      )}
                    </>
                  ) : (
                    <div className="sidebar-auth-cta">
                      <button
                        type="button"
                        className="sidebar-auth-cta__signup"
                        onClick={openSignupModal}
                      >
                        {__("Sign Up")}
                      </button>
                      <div className="sidebar-auth-cta__login">
                        {__("Already a member?")}{" "}
                        <a href="#" onClick={openLoginModal}>{__("Log in")}</a>
                      </div>
                    </div>
                  )}
                </li>
              </ul>
            </div>
            <div className="sidebar-menu-section  py-3 px-3">
              <ul
                className="sidebar-menu-list sidebar-menu-list-flex list-unstyled"
              >
                {accordionData.map((section) => (
                  <li key={section.key} className="sidebar-list-item mb-2">
                    {section.children ? (
                      <>
                        <div
                          className="sidebar-accordion-button"
                          style={rowStyle(section)}
                          onClick={() => setOpen(open === section.key ? null : section.key)}
                          onMouseEnter={() => setHoveredItem(section.key)}
                          onMouseLeave={() => setHoveredItem(null)}
                        >
                          <div className="menu-item-area">
                            <div className="menu-icon" style={section.accentHex ? { color: section.accentHex } : undefined}>
                              {section.icon}
                            </div>

                            <div className="menu-text">{section.label}{badgePill(section.badge)}</div>
                          </div>
                          <div
                            className={`accordion-chevron ${open === section.key ? 'open' : 'closed'}`}
                          >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                              <path
                                d="M4.293 8.293a1 1 0 0 1 1.414 0L12 14.586l6.293-6.293a1 1 0 1 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 0-1.414"
                                fill="currentColor"
                              />
                            </svg>
                          </div>
                        </div>
                        {open === section.key && (
                          <ul className="accordion-submenu">
                            {section.children.map((child, idx) => (
                              <li key={idx} className="accordion-submenu-item">
                                <Link
                                  className={`nav-sidebar-item nav-sidebar-item--nested ${submenuHover === `${section.key}-${idx}` ? 'hover' : ''} ${isActiveLink(child.url) ? 'active' : ''}`}
                                  to={child.url}
                                  style={rowStyle(child)}
                                  onClick={() => {
                                    if (props.isMobileDevice) {
                                      props.setIsSidebarCollapsed(!props.isSidebarCollapsed);
                                    }
                                  }}
                                  onMouseEnter={() => setSubmenuHover(`${section.key}-${idx}`)}
                                  onMouseLeave={() => setSubmenuHover(null)}
                                >
                                  <div className="nav-sidebar-item__content">
                                    <div className="m-icon-container nav-sidebar-item-icon" style={child.accentHex ? { color: child.accentHex } : undefined}>
                                      {child.icon ? (
                                        child.icon
                                      ) : (
                                        <svg
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          width="16"
                                          height="16"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <circle cx="12" cy="12" r="3" fill="#A2A5AF" />
                                        </svg>
                                      )}
                                    </div>
                                    <span className="nav-sidebar-item-text">
                                      {child.label}
                                      {badgePill(child.badge)}
                                    </span>
                                  </div>
                                </Link>
                              </li>
                            ))}
                          </ul>
                        )}
                      </>
                    ) : (
                      <Link
                        className={`sidebar-link-no-children ${isActiveLink(section.url) ? 'active' : ''}`}
                        to={section.url}
                        style={rowStyle(section)}
                        onClick={() => {
                          if (props.isMobileDevice) {
                            props.setIsSidebarCollapsed(!props.isSidebarCollapsed);
                          }
                        }}
                      >
                        <div className="nav-sidebar-item__content">
                          <div className="m-icon-container nav-sidebar-item-icon" style={section.accentHex ? { color: section.accentHex } : undefined}>
                            {section.icon}
                          </div>
                          <span className="nav-sidebar-item-text">
                            {section.label}
                            {badgePill(section.badge)}
                          </span>
                        </div>
                      </Link>
                    )}
                  </li>
                ))}
              </ul>


              <div className="sidebar-nav-stack">
              <SidebarNavLink
                to="/promotions"
                active={isActiveLink("/promotions")}
                onMouseEnter={() => setHoveredItem("bonus-hub")}
                onMouseLeave={() => setHoveredItem(null)}
                label={__("Promotions")}
                icon={(
                  <svg className="sidebar-icon" fill="#F9D722" version="1.1" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 20.51 20.51" aria-hidden="true">
                    <path d="M15.953,2.867c0.01-0.942,0.015-2.002-0.521-2.542c-0.28-0.282-0.672-0.388-1.106-0.289l-0.578,0.13 c-0.932,0.209-2.293,1.235-2.994,2.075c-0.701-0.84-2.061-1.866-2.994-2.075l-0.577-0.13C5.744-0.062,5.356,0.043,5.076,0.325 L2.442,3.149v15.625l6.511,1.735V6.622c0.355-0.515,0.667-1.06,0.892-1.6h0.375c0.225,0.541,0.536,1.084,0.892,1.6V20.51 l6.511-1.735V3.149L15.953,2.867z" />
                  </svg>
                )}
              />
              <SidebarNavLink
                to="/providers"
                active={isActiveLink("/providers")}
                onMouseEnter={() => setHoveredItem("providers")}
                onMouseLeave={() => setHoveredItem(null)}
                label={__("Providers")}
                icon={<ProvidersIcon />}
              />
              <SidebarNavLink
                to="/tournaments"
                active={isActiveLink("/tournaments")}
                onMouseEnter={() => setHoveredItem("race")}
                onMouseLeave={() => setHoveredItem(null)}
                label={__("Tournaments")}
                icon={<RaceIcon />}
              />
              {/* Gamification hub. The same links show for guests: every route
                  serves a dedicated logged-out teaser (AuthGate), never an empty
                  personal dashboard, and the teasers are the conversion surface —
                  without these links /wheel and friends would be unreachable. */}
              <SidebarNavLink
                to="/missions"
                active={isActiveLink("/missions")}
                label={__("Missions")}
                icon={<MissionsIcon />}
              />
              <SidebarNavLink
                to="/rewards"
                active={isActiveLink("/rewards")}
                label={__("Rewards")}
                icon={<RewardsIcon />}
              />
              <SidebarNavLink
                to="/store"
                active={isActiveLink("/store")}
                label={__("Store")}
                icon={<StoreIcon />}
              />
              <SidebarNavLink
                to="/wheel"
                active={isActiveLink("/wheel")}
                onMouseEnter={() => setHoveredItem("wheel")}
                onMouseLeave={() => setHoveredItem(null)}
                label={__("Wheel")}
                icon={<WheelIcon />}
              />
              <SidebarNavLink
                to="/vip"
                active={isActiveLink("/vip")}
                label={__("VIP Club")}
                icon={<VipIcon />}
              />
              </div>
            </div>
            {props.isAuthenticated && (
              <div className="sidebar-menu-section py-3 px-3 d-flex flex-column align-items-center w-100">
                <Link
                  to="/dashboard/my-games"
                  className={`sidebar-btn w-100 d-flex justify-content-left mb-2 ${isActiveLink('/dashboard/my-games') ? 'active' : ''}`}

                  onMouseEnter={() => setHoveredItem("bonus-hub")}
                  onMouseLeave={() => setHoveredItem(null)}
                  onClick={() => {
                    if (props.isMobileDevice) {
                      props.setIsSidebarCollapsed(!props.isSidebarCollapsed);
                    }
                  }}
                >

                  <svg
                    id="SvgjsSvg1001"
                    width="28"
                    height="28"
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    xlink="http://www.w3.org/1999/xlink"
                    svgjs="http://svgjs.com/svgjs"
                  >
                    <defs id="SvgjsDefs1002"></defs>
                    <g id="SvgjsG1008">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        enable-background="new 0 0 484.8 484.8"
                        viewBox="0 0 484.8 484.8"
                        width="28"
                        height="28"
                      >
                        <path
                          d="M242.4,484.8c133.7,0,242.4-108.8,242.4-242.4C484.8,108.7,376,0,242.4,0C108.7,0,0,108.7,0,242.4
				S108.7,484.8,242.4,484.8z M242.4,34.3c114.8,0,208.1,93.4,208.1,208.1c0,114.8-93.4,208.1-208.1,208.1
				c-114.8,0-208.1-93.4-208.1-208.1C34.3,127.6,127.6,34.3,242.4,34.3z"
                          fill="#666666"
                          class="color000 svgShape"
                        ></path>
                        <path
                          d="M230.1,380.6l0.2,0.2c3.2,3.2,7.6,5.1,12.1,5.1l0,0c4.5,0,8.9-1.8,12.1-5l108.9-108.8c16.1-16.1,24.9-37.4,24.9-60.1
				s-8.8-44.1-24.9-60.1c-16-16-37.4-24.9-60-24.9c-22.7,0-44,8.9-60.1,24.9l-0.9,0.9l-1-1c-16.1-16.1-37.5-24.9-60.2-24.9
				s-44,8.8-60,24.9c-33.1,33.1-33.1,87,0.1,120.2L230.1,380.6z M145.6,176c9.6-9.6,22.2-14.8,35.7-14.8s26.3,5.3,35.9,14.9
				l13.1,13.1c6.7,6.7,17.6,6.7,24.3,0l13-13c9.6-9.6,22.3-14.9,35.9-14.9c13.5,0,26.2,5.3,35.8,14.8c9.6,9.6,14.8,22.3,14.8,35.8
				s-5.3,26.3-14.9,35.9l-96.7,96.7l-96.8-96.8c-9.6-9.6-14.9-22.3-14.9-35.8C130.7,198.3,136,185.6,145.6,176z"
                          fill="#666666"
                          class="color000 svgShape"
                        ></path>
                      </svg>
                    </g>
                  </svg>
                  <span className="fw-bold">{__("Favourites Games")}</span>
                </Link>
              </div>
            )}
            {/* Bottom section pinned to bottom using flex */}
            <div className="sidebar-bottom mt-auto d-flex flex-column align-items-center w-100">
              <div className="sidebar-support-lang px-3 mb-3 w-100 d-flex flex-column align-items-stretch">
                <a
                  onClick={handleSupportSidebarToggle}
                  href="#"
                  className="sidebar-support-btn w-100 mb-2 d-flex"
                  role="button"
                  aria-expanded={!!props.supportSidebarOpen}
                >
                  {/* Support SVG */}
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="me-2"
                  >
                    <path
                      d="M12 18.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m5.5-8.5v-1a5.5 5.5 0 1 0-11 0v1H9a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6.5v.25a2.25 2.25 0 0 0 2.096 2.245l.154.005h1.128a2.251 2.251 0 1 1 0 1.5H8.75a3.75 3.75 0 0 1-3.745-3.55L5 16.5V9.25a7 7 0 0 1 14 0v5a2 2 0 0 1-1.85 1.994l-.15.006h-2a1 1 0 0 1-.993-.883L14 15.25v-4a1 1 0 0 1 .883-.993L15 10.25zm-9 1.5h-2v3h2zm9 0h-2v3H17a.5.5 0 0 0 .492-.41l.008-.09z"
                      fill="currentColor"
                    />
                  </svg>
                  Support
                </a>

                {/* <LanguageSwitcherAccordion {...props} /> */}
              </div>
              {/* Social media icons (Instagram/Telegram) removed for GoldenClover. */}
            </div>
          </div>
        </>
      )}
      {props.isSidebarCollapsed && (
        <>
          <div className="sidebar-menu-main slide-up-opacity flex-grow-1 d-flex flex-column">
            <div className="sidebar-menu-section  py-3 px-3">
              <Link
                to="/games/slots"
                className={`sidebar-btn w-100 d-flex justify-content-center align-items-center mb-2 ${isActiveLink('/games/slots') || isActiveLink('/lobby') ? 'active' : ''}`}
                onClick={() => {
                  if (props.isMobileDevice) {
                    props.setIsSidebarCollapsed(!props.isSidebarCollapsed);
                  }
                }}
              >
                <svg className="sidebar-icon" fill="#F9D722" height="34px" width="34px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 420.751 420.751" >

                  <g id="SVGRepo_bgCarrier" strokeWidth="0" />

                  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />

                  <g id="SVGRepo_iconCarrier"> <g> <g> <path d="M374.431,130.094c5.233,0,9.969-2.12,13.399-5.55c3.43-3.43,5.55-8.166,5.55-13.399c0-10.465-8.484-18.944-18.949-18.944 s-18.949,8.484-18.949,18.944C355.482,121.61,363.965,130.094,374.431,130.094z" /> <path d="M99.092,328.642c-9.8,0-17.741,7.946-17.741,17.741c0,9.795,7.946,17.741,17.741,17.741s17.741-7.941,17.741-17.741 C116.833,336.584,108.892,328.642,99.092,328.642z" /> <path d="M365.962,140.385v152.873h16.937V140.385c-2.56,1.29-5.407,2.084-8.468,2.084 C371.369,142.469,368.522,141.67,365.962,140.385z" /> <path d="M245.74,328.642c-9.8,0-17.741,7.946-17.741,17.741c0,9.795,7.941,17.741,17.741,17.741s17.741-7.941,17.741-17.741 C263.48,336.584,255.539,328.642,245.74,328.642z" /> <path d="M332.037,11.658H9.907C4.434,11.658,0,16.092,0,21.565v387.528h341.949V21.565 C341.944,16.092,337.51,11.658,332.037,11.658z M231.511,35.82c8.238,0,14.915,6.676,14.915,14.915s-6.677,14.915-14.915,14.915 c-8.238,0-14.915-6.676-14.915-14.915C216.597,42.496,223.273,35.82,231.511,35.82z M172.416,24.064 c14.725,0,26.665,11.94,26.665,26.665c0,14.725-11.94,26.665-26.665,26.665c-14.725,0-26.665-11.94-26.665-26.665 C145.751,36.004,157.691,24.064,172.416,24.064z M113.321,35.82c8.238,0,14.915,6.676,14.915,14.915s-6.677,14.915-14.915,14.915 c-8.238,0-14.915-6.676-14.915-14.915C98.412,42.496,105.088,35.82,113.321,35.82z M99.092,374.41 c-15.478,0-28.022-12.544-28.022-28.022s12.549-28.022,28.022-28.022c15.478,0,28.022,12.549,28.022,28.022 C127.114,361.861,114.57,374.41,99.092,374.41z M172.416,374.41c-15.478,0-28.022-12.544-28.022-28.022 s12.544-28.022,28.022-28.022c15.478,0,28.022,12.549,28.022,28.022C200.438,361.861,187.894,374.41,172.416,374.41z M245.74,374.41c-15.478,0-28.022-12.544-28.022-28.022s12.544-28.022,28.022-28.022c15.478,0,28.022,12.549,28.022,28.022 C273.761,361.861,261.217,374.41,245.74,374.41z M320.323,280.407H24.509V90.987h295.813V280.407z" /> <path d="M172.416,328.642c-9.8,0-17.741,7.946-17.741,17.741c0,9.795,7.946,17.741,17.741,17.741 c9.8,0,17.741-7.941,17.741-17.741C190.157,336.584,182.216,328.642,172.416,328.642z" /> <path d="M113.326,108.006h-0.005H36.618v155.121h76.708V108.006z M103.434,172.104c-0.01,0-0.015,0-0.02,0 c0,0.107,0.02,0.195,0.02,0.302c0,18.186-27.192,24.827-16.246,50.714H57.718c-3.722-23.219,28.667-35.164,30.853-47.8 c-3.195,1.244-6.359,2.381-11.069,2.381c-9.651,0-10.593-4.721-23.634-5.478v9.175h-7.363v-20.7h7.363v0.113 c13.041,0.763,13.983,5.478,23.634,5.478c10.491,0,13.292-5.596,25.933-5.596V172.104z" /> <path d="M381.348,303.278h-28.437v78.812h28.437c21.765,0,39.404-17.643,39.404-39.404 C420.756,320.922,403.113,303.278,381.348,303.278z" /> <path d="M303.324,108.006h-0.005h-76.703v155.121h76.708V108.006z M293.432,172.104c-0.01,0-0.015,0-0.02,0 c0,0.107,0.02,0.195,0.02,0.302c0,18.186-27.192,24.827-16.246,50.714h-29.471c-3.722-23.219,28.667-35.164,30.853-47.8 c-3.195,1.244-6.359,2.381-11.069,2.381c-9.651,0-10.593-4.721-23.634-5.478v9.175h-7.363v-20.7h7.363v0.113 c13.041,0.763,13.988,5.478,23.634,5.478c10.491,0,13.292-5.596,25.933-5.596V172.104z" /> <path d="M208.323,108.006h-76.708v155.121h76.708V108.006z M198.436,172.104c-0.01,0-0.015,0-0.021,0 c0,0.107,0.021,0.195,0.021,0.302c0,18.186-27.192,24.827-16.246,50.714h-29.471c-3.722-23.219,28.667-35.164,30.853-47.8 c-3.195,1.244-6.359,2.381-11.069,2.381c-9.646,0-10.593-4.721-23.634-5.478v9.175h-7.363v-20.7h7.363v0.113 c13.041,0.763,13.988,5.478,23.634,5.478c10.491,0,13.292-5.596,25.933-5.596V172.104z" /> </g> </g> </g>

                </svg>

                {/* <span className="fw-bold small">{__("Casino")}</span> */}
              </Link>

              <Link
                to="/games/live-casino"
                className={`sidebar-btn w-100 d-flex justify-content-center align-items-center mb-2 ${isActiveLink('/games/live-casino') ? 'active' : ''}`}
                onClick={() => {
                  if (props.isMobileDevice) {
                    props.setIsSidebarCollapsed(!props.isSidebarCollapsed);
                  }
                }}
              >
                <svg className="sidebar-icon" fill="#F9D722" width="34px" height="34px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" id="Croupier" version="1.1" >

                  <g id="SVGRepo_bgCarrier" strokeWidth="0" />

                  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />

                  <g id="SVGRepo_iconCarrier"> <g> <path d="M408.709,372.949c-1.652-16.627-11.465-31.202-26.248-38.988l-68.949-36.313l-16.546-18.374v-13.351 c10.308-6.362,18.824-14.938,25.087-24.905c17.756,50.995,67.18,43.242,54.729,37.582c-13.2-6-10.801-21.6-3.601-50.399 c7.2-28.8,4.8-42-10.8-57.6c-3.447-3.448-7.128-5.364-10.771-6.265c-0.564-2.503-1.517-4.856-2.797-6.999 c5.604-12.011,9.638-31.11,2.938-46.341C351.11,70.711,307.908,38.2,254.681,38.2c-53.626,0-97.1,32.997-97.1,73.7h0.077 c-6.302,15.439-1.965,34.563,3.732,46.281c-1.85,3.403-2.908,7.296-2.908,11.434v8.355c0,11.249,7.77,20.716,18.225,23.317 c0.586,27.041,15.057,51.677,38.289,65.401v12.586l-16.581,18.412l-68.875,36.275c-14.784,7.786-24.597,22.361-26.249,38.988 L93.268,473.8h325.464L408.709,372.949z M246.373,352.08l-5.273,47.627l-13.905-34.71l17.072-19.396L246.373,352.08z M267.722,345.596l17.052,19.387l-13.888,34.664l-5.271-47.566L267.722,345.596z M297.102,360.846l-33.19-37.705l20.498-24.118 l6.892-8.107l12.234,13.587L297.102,360.846z M188.688,199.581v-9.586h-6.182c-6.63,0-12.024-5.394-12.024-12.024v-8.355 c0-0.225,0.021-0.444,0.034-0.666c0.223,0.015,0.443,0.017,0.656,0.033c0.022,0,0.039,0,0.061,0 c5.455,0.243,10.798-3.372,16.942-11.391h0.514v-0.682c4.569-6.102,9.587-14.605,15.425-25.754 c8.096-15.413,20.845-16.07,30.512-13.646c2.836,1.878,4.669,2.959,4.669,2.959l14.175,8.47l11.312-7.389 c7.699-4.067,29.203-12.71,40.898,9.606c13.885,26.511,23.14,38.123,32.718,37.828c0.38,0,0.753,0,1.114-0.05 c0.174-0.021,0.398-0.115,0.652-0.254c0.024,0.311,0.053,0.621,0.053,0.938v8.355c0,6.63-5.395,12.024-12.025,12.024h-6.182v9.586 c0,0.968-0.028,1.931-0.07,2.892c-0.012,0.244-0.024,0.487-0.037,0.73c-0.049,0.873-0.111,1.742-0.193,2.608 c-0.009,0.089-0.014,0.179-0.023,0.268c-0.097,0.979-0.219,1.953-0.359,2.923c-0.023,0.16-0.049,0.318-0.074,0.478 c-0.139,0.912-0.293,1.819-0.471,2.722c-0.012,0.06-0.021,0.121-0.033,0.182c-0.203,1.015-0.428,2.023-0.676,3.024 c-0.005,0.019-0.01,0.037-0.015,0.056c-0.25,1.002-0.522,1.997-0.819,2.984c-0.004,0.014-0.008,0.028-0.012,0.042 c-0.604,2.009-1.303,3.985-2.091,5.921c-5.584,13.707-15.714,25.4-29.085,32.832l-3.085,1.715v20.877L263.63,304.94l-7.649,8.999 l-28.985-34.102v-20.277l-3.19-1.69C202.144,246.392,188.688,224.056,188.688,199.581z M220.661,290.914l27.389,32.225 l-33.189,37.703l-6.435-56.34L220.661,290.914z M106.52,461.8l8.712-87.664c1.252-12.604,8.691-23.655,19.899-29.558l62.061-32.686 l0.12,1.047l-25.918,55.824c-1.665,3.587-0.53,7.852,2.698,10.135l81.89,57.953l81.891-57.953 c3.228-2.283,4.362-6.548,2.697-10.135l-25.918-55.824l0.121-1.066l62.098,32.705c11.207,5.902,18.646,16.953,19.898,29.558 l8.713,87.664H106.52z" /> <path d="M362.645,416.668h-46.113h-3.055c-2.028,0-3.673,1.958-3.673,4.373v15.475c0,2.415,1.645,4.373,3.673,4.373h49.168 c1.775,0,3.256-1.499,3.599-3.492c0.049-0.284,0.075-0.579,0.075-0.881v-2.355v-13.119 C366.318,418.626,364.673,416.668,362.645,416.668z" /> </g> </g>

                </svg>

                {/* <span className="fw-bold small">{__("Live Casino")}</span> */}
              </Link>
              <Link
                to="/providers"
                className={`sidebar-btn w-100 d-flex justify-content-center align-items-center mb-2 ${isActiveLink('/providers') ? 'active' : ''}`}
                onClick={() => {
                  if (props.isMobileDevice) {
                    props.setIsSidebarCollapsed(!props.isSidebarCollapsed);
                  }
                }}
              >
                <ProvidersIcon size={34} />
              </Link>
              <Link
                to="/tournaments"
                className={`sidebar-btn w-100 d-flex justify-content-center align-items-center mb-2 ${isActiveLink("/tournaments") ? "active" : ""}`}
                onMouseEnter={() => setHoveredItem("race")}
                onMouseLeave={() => setHoveredItem(null)}
                onClick={closeSidebarOnMobile}
              >
                <RaceIcon size={34} />
              </Link>
              {/* Same guest-visible teaser links as the expanded rail — every
                  route serves a logged-out teaser via AuthGate. */}
              <SidebarNavLink
                to="/missions"
                active={isActiveLink("/missions")}
                title={__("Missions")}
                icon={<MissionsIcon size={34} />}
              />
              <SidebarNavLink
                to="/rewards"
                active={isActiveLink("/rewards")}
                title={__("Rewards")}
                icon={<RewardsIcon size={34} />}
              />
              <SidebarNavLink
                to="/store"
                active={isActiveLink("/store")}
                title={__("Store")}
                icon={<StoreIcon size={34} />}
              />
              <SidebarNavLink
                to="/wheel"
                active={isActiveLink("/wheel")}
                onMouseEnter={() => setHoveredItem("wheel")}
                onMouseLeave={() => setHoveredItem(null)}
                title={__("Wheel")}
                icon={<WheelIcon size={34} />}
              />
              <SidebarNavLink
                to="/vip"
                active={isActiveLink("/vip")}
                title={__("VIP Club")}
                icon={<VipIcon size={34} />}
              />
              <Divider />
              <Link
                to="/promotions"
                className={`sidebar-btn w-100 d-flex justify-content-center align-items-center mb-2 ${isActiveLink('/promotions') ? 'active' : ''}`}
                onMouseEnter={() => setHoveredItem("bonus-hub")}
                onMouseLeave={() => setHoveredItem(null)}
                onClick={() => {
                  if (props.isMobileDevice) {
                    props.setIsSidebarCollapsed(!props.isSidebarCollapsed);
                  }
                }}
              >
                <svg className="sidebar-icon" fill="#F9D722" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" width="34px" height="34px" viewBox="0 0 20.51 20.51">
                  <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                  <g id="SVGRepo_iconCarrier">
                    <g>
                      <g>
                        <path d="M13.427,7.299c0.581,0.049-0.222-0.475,0.093-0.988c-1.087-0.301-1.739-1.119-2.394-2.172 C11.125,4.782,12.845,7.251,13.427,7.299z" />
                        <path d="M6.989,6.311c0.315,0.513-0.488,1.038,0.094,0.988c0.581-0.049,2.3-2.517,2.3-3.16C8.729,5.191,8.077,6.009,6.989,6.311z" />
                        <path d="M8.281,2.304L7.952,2.23c-0.638-0.144-1.16,0.273-1.16,0.927v0.025c0,0.654,0.521,1.07,1.16,0.928l0.329-0.074 C8.918,3.894,9.44,3.504,9.44,3.171S8.918,2.447,8.281,2.304z" />
                        <path d="M15.953,2.867c0.01-0.942,0.015-2.002-0.521-2.542c-0.28-0.282-0.672-0.388-1.106-0.289l-0.578,0.13 c-0.932,0.209-2.293,1.235-2.994,2.075c-0.1-0.037-0.205-0.055-0.312-0.055h-0.375c-0.107,0-0.212,0.019-0.312,0.055 c-0.701-0.84-2.061-1.866-2.994-2.075l-0.577-0.13C5.744-0.062,5.356,0.043,5.076,0.325c-0.534,0.541-0.53,1.599-0.521,2.542 L2.442,3.149v15.625l6.511,1.735V6.622c0.355-0.515,0.667-1.06,0.892-1.6c0.072,0.019,0.147,0.029,0.223,0.029h0.375 c0.076,0,0.151-0.011,0.223-0.029c0.225,0.541,0.536,1.084,0.892,1.6V20.51l6.511-1.735V3.149L15.953,2.867z M15.431,3.213v0.043 c0,1.147-0.915,1.879-2.033,1.627l-0.578-0.129c-0.484-0.108-0.925-0.301-1.274-0.53c0.988,1.061,2.126,1.416,3.668,1.843 c-0.564,0.922,0.737,2.918-0.305,2.832c-0.915-0.076-3.408-2.503-3.995-4.755c-0.109,0.228-0.274,0.387-0.472,0.387h-0.375 c-0.198,0-0.364-0.159-0.472-0.387c-0.586,2.252-3.08,4.68-3.996,4.755C4.557,8.985,5.858,6.99,5.294,6.067 c1.542-0.427,2.681-0.782,3.669-1.843c-0.35,0.229-0.791,0.42-1.275,0.53L7.11,4.883C5.992,5.135,5.076,4.402,5.076,3.256V3.213 c0-1.147-0.126-2.921,0.992-2.668l0.579,0.129c0.987,0.223,2.625,1.592,2.995,2.312c0.108-0.17,0.258-0.279,0.425-0.279h0.375 c0.167,0,0.317,0.108,0.425,0.279c0.369-0.72,2.007-2.09,2.994-2.312l0.579-0.129C15.558,0.293,15.431,2.067,15.431,3.213z" />
                        <path d="M12.558,2.23l-0.329,0.074c-0.638,0.143-1.159,0.532-1.159,0.866c0,0.333,0.521,0.723,1.159,0.866l0.329,0.074 c0.638,0.144,1.159-0.274,1.159-0.928V3.156C13.717,2.504,13.195,2.086,12.558,2.23z" />
                      </g>
                    </g>
                  </g>
                </svg>
                {/* <span className="fw-bold">{__("Promotions")}</span> */}
              </Link>

              {props.isAuthenticated && (

                <Link
                  to="/dashboard/my-games"
                  className={`sidebar-btn w-100 d-flex justify-content-center align-items-center mb-2 ${isActiveLink('/wheel') ? 'active' : ''}`}
                  onMouseEnter={() => setHoveredItem("wheel")}
                  onMouseLeave={() => setHoveredItem(null)}
                  onClick={() => {
                    if (props.isMobileDevice) {
                      props.setIsSidebarCollapsed(!props.isSidebarCollapsed);
                    }
                  }}
                >

                  <svg
                    id="SvgjsSvg1001"
                    width="28"
                    height="28"
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    xlink="http://www.w3.org/1999/xlink"
                    svgjs="http://svgjs.com/svgjs"
                  >
                    <defs id="SvgjsDefs1002"></defs>
                    <g id="SvgjsG1008">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        enable-background="new 0 0 484.8 484.8"
                        viewBox="0 0 484.8 484.8"
                        width="28"
                        height="28"
                      >
                        <path
                          d="M242.4,484.8c133.7,0,242.4-108.8,242.4-242.4C484.8,108.7,376,0,242.4,0C108.7,0,0,108.7,0,242.4
				S108.7,484.8,242.4,484.8z M242.4,34.3c114.8,0,208.1,93.4,208.1,208.1c0,114.8-93.4,208.1-208.1,208.1
				c-114.8,0-208.1-93.4-208.1-208.1C34.3,127.6,127.6,34.3,242.4,34.3z"
                          fill="#666666"
                          class="color000 svgShape"
                        ></path>
                        <path
                          d="M230.1,380.6l0.2,0.2c3.2,3.2,7.6,5.1,12.1,5.1l0,0c4.5,0,8.9-1.8,12.1-5l108.9-108.8c16.1-16.1,24.9-37.4,24.9-60.1
				s-8.8-44.1-24.9-60.1c-16-16-37.4-24.9-60-24.9c-22.7,0-44,8.9-60.1,24.9l-0.9,0.9l-1-1c-16.1-16.1-37.5-24.9-60.2-24.9
				s-44,8.8-60,24.9c-33.1,33.1-33.1,87,0.1,120.2L230.1,380.6z M145.6,176c9.6-9.6,22.2-14.8,35.7-14.8s26.3,5.3,35.9,14.9
				l13.1,13.1c6.7,6.7,17.6,6.7,24.3,0l13-13c9.6-9.6,22.3-14.9,35.9-14.9c13.5,0,26.2,5.3,35.8,14.8c9.6,9.6,14.8,22.3,14.8,35.8
				s-5.3,26.3-14.9,35.9l-96.7,96.7l-96.8-96.8c-9.6-9.6-14.9-22.3-14.9-35.8C130.7,198.3,136,185.6,145.6,176z"
                          fill="#666666"
                          class="color000 svgShape"
                        ></path>
                      </svg>
                    </g>
                  </svg>
                  {/* <span className="fw-bold">{__("Favourites Games")}</span> */}
                </Link>

              )}
            </div>

            {/* Bottom section pinned to bottom using flex */}
            <div className="sidebar-bottom mt-auto flex-column align-items-center w-100">
              <div
                className="sidebar-support-lang sidebar-bottom-padding px-3 mb-3 w-100 d-flex flex-column align-items-stretch"
              >
                <button
                  type="button"
                  onClick={handleSupportSidebarToggle}
                  className="sidebar-support-btn w-100 mb-2 d-flex align-items-center justify-content-center"
                  aria-pressed={!!props.supportSidebarOpen}
                >
                  {/* Support SVG */}
                  <svg width="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12 18.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m5.5-8.5v-1a5.5 5.5 0 1 0-11 0v1H9a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6.5v.25a2.25 2.25 0 0 0 2.096 2.245l.154.005h1.128a2.251 2.251 0 1 1 0 1.5H8.75a3.75 3.75 0 0 1-3.745-3.55L5 16.5V9.25a7 7 0 0 1 14 0v5a2 2 0 0 1-1.85 1.994l-.15.006h-2a1 1 0 0 1-.993-.883L14 15.25v-4a1 1 0 0 1 .883-.993L15 10.25zm-9 1.5h-2v3h2zm9 0h-2v3H17a.5.5 0 0 0 .492-.41l.008-.09z"
                      fill="currentColor"
                    />
                  </svg>
                  {/* Support */}
                </button>

                {/* <LanguageSwitcherAccordion {...props} /> */}
              </div>
            </div>
          </div>
        </>
      )}
    </aside>
    {!props.isMobileDevice && (
      <button
        type="button"
        className="sidebar-edge-toggle"
        id="sideToggle"
        onClick={toggleSidebar}
        aria-label={isCollapsed ? __("Expand menu") : __("Collapse menu")}
        aria-controls="primary-sidebar"
        aria-expanded={!isCollapsed}
      >
        {isCollapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
      </button>
    )}
    </>
  );
};

export default Sidebar;
